var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.footerHTML),expression:"footerHTML"}],ref:"footer",attrs:{"id":"tripla-footer-container"}})
}
var staticRenderFns = []

export { render, staticRenderFns }